import { useState, useEffect } from "react";
import Step1Upload from "@/pages/smartfile/Step1Upload";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Sparkles } from "lucide-react";
import { isAIDisabled, setAIDisabled } from "@/lib/smartfile-ai-preference";

export function CompactSmartfile() {
  const navigate = useNavigate();
  const [disableAI, setDisableAI] = useState(() => isAIDisabled());

  // Salvar no localStorage sempre que mudar
  useEffect(() => {
    setAIDisabled(disableAI);
  }, [disableAI]);

  return (
    <Card className="border-border/50 shadow-sm h-fit">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-4">
          <div className="flex flex-col space-y-1.5 flex-1">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Sparkles className="h-4 w-4 text-primary" />
              Captura Inteligente
            </CardTitle>
            <CardDescription className="text-xs">
              Insira os dados clínicos de qualquer paciente:
            </CardDescription>
          </div>
          <div className="flex items-center gap-2 pt-1">
            <Checkbox
              id="disable-ai"
              checked={disableAI}
              onCheckedChange={(checked) => setDisableAI(checked === true)}
            />
            <Label
              htmlFor="disable-ai"
              className="text-xs text-muted-foreground cursor-pointer whitespace-nowrap"
            >
              Desativar Resumo e Insights IA
            </Label>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <Step1Upload
          patientId={null}
          onComplete={(sessionId) => {
            navigate(`/app/smartfile?sessionId=${sessionId}`);
          }}
          compact={true}
          disableAI={disableAI}
        />
      </CardContent>
    </Card>
  );
}
